import { EditorView } from "@codemirror/view";
import {
    accentIconStyles,
    accentText,
    directivePrettyStyles,
} from "../shared/theme-helpers";

const CONFIG_ACCENT = "--cm-define-accent";
const OUTPUT_ACCENT = "--cm-render-accent";
const INPUTS_ACCENT = "--cm-use-accent";

export const fenceTheme = EditorView.baseTheme({
    ".cm-magic-fence-line-config": {
        backgroundColor: `color-mix(in oklab, var(${CONFIG_ACCENT}) 2.5%, transparent)`,
        borderLeft: `1px solid color-mix(in oklab, var(${CONFIG_ACCENT}) 22%, transparent)`,
    },
    ".cm-magic-fence-line-output": {
        backgroundColor: `color-mix(in oklab, var(${OUTPUT_ACCENT}) 3.5%, transparent)`,
        borderLeft: `1px solid color-mix(in oklab, var(${OUTPUT_ACCENT}) 28%, transparent)`,
    },
    ".cm-magic-fence-line-inputs": {
        backgroundColor: `color-mix(in oklab, var(${INPUTS_ACCENT}) 3.2%, transparent)`,
        borderLeft: `1px solid color-mix(in oklab, var(${INPUTS_ACCENT}) 26%, transparent)`,
    },
    ".cm-magic-fence-line-open": {
        borderTopLeftRadius: "4px",
    },
    ".cm-magic-fence-line-close": {
        borderBottomLeftRadius: "4px",
        opacity: "0.82",
    },
    ".cm-magic-fence-line-body": {
        backgroundColor: "transparent",
    },
    ".cm-magic-fence-body-hidden": {
        display: "none",
    },
    // When a FenceBodyWidget replaces the text of a line,
    // CodeMirror still wraps it in .cm-line with cm-widgetBuffer
    // images that enforce the line-height grid.  Collapse them so
    // the widget sits flush against its neighbours.
    ".cm-magic-fence-body": {
        display: "block",
    },
    ".cm-line:has(.cm-magic-fence-body)": {
        lineHeight: "0",
    },
    ".cm-line:has(.cm-magic-fence-body) .cm-widgetBuffer": {
        display: "none",
    },
    ".cm-magic-fence-mark": {
        fontWeight: "500",
        letterSpacing: "0.02em",
        borderRadius: "4px",
        padding: "0 2px",
    },
    ".cm-magic-fence-mark-config": {
        color: `var(${CONFIG_ACCENT})`,
        backgroundColor: `color-mix(in oklab, var(${CONFIG_ACCENT}) 7%, transparent)`,
    },
    ".cm-magic-fence-mark-output": {
        color: `var(${OUTPUT_ACCENT})`,
        backgroundColor: `color-mix(in oklab, var(${OUTPUT_ACCENT}) 8%, transparent)`,
    },
    ".cm-magic-fence-mark-inputs": {
        color: `var(${INPUTS_ACCENT})`,
        backgroundColor: `color-mix(in oklab, var(${INPUTS_ACCENT}) 8%, transparent)`,
    },
    ".cm-magic-fence-pretty": {
        ...directivePrettyStyles(CONFIG_ACCENT, {
            gap: "4px",
            padding: "1px 6px 1px 2px",
            borderRadius: "6px",
            backgroundPercent: 4,
            hoverBackgroundPercent: 8,
            cursor: "pointer",
            transition: "background-color 0.15s ease",
        }),
        opacity: "0.72",
    },
    ".cm-magic-fence-pretty-output": {
        ...directivePrettyStyles(OUTPUT_ACCENT, {
            gap: "4px",
            padding: "1px 6px 1px 2px",
            borderRadius: "6px",
            backgroundPercent: 5,
            hoverBackgroundPercent: 9,
            cursor: "pointer",
            transition: "background-color 0.15s ease",
        }),
        opacity: "0.72",
    },
    ".cm-magic-fence-pretty-inputs": {
        ...directivePrettyStyles(INPUTS_ACCENT, {
            gap: "4px",
            padding: "1px 6px 1px 2px",
            borderRadius: "6px",
            backgroundPercent: 5,
            hoverBackgroundPercent: 9,
            cursor: "pointer",
            transition: "background-color 0.15s ease",
        }),
        opacity: "0.72",
    },
    ".cm-magic-fence-pretty-icon-config": accentIconStyles(CONFIG_ACCENT),
    ".cm-magic-fence-pretty-icon-output": accentIconStyles(OUTPUT_ACCENT),
    ".cm-magic-fence-pretty-icon-inputs": accentIconStyles(INPUTS_ACCENT),
    ".cm-magic-fence-pretty-kind": accentText(CONFIG_ACCENT, {
        fontFamily: "ui-monospace, 'SF Mono', Menlo, Monaco, monospace",
        fontWeight: "600",
        fontSize: "11px",
        letterSpacing: "0.01em",
    }),
    ".cm-magic-fence-pretty-output .cm-magic-fence-pretty-kind": accentText(
        OUTPUT_ACCENT,
        {
            fontFamily: "ui-monospace, 'SF Mono', Menlo, Monaco, monospace",
            fontWeight: "600",
            fontSize: "11px",
            letterSpacing: "0.01em",
        },
    ),
    ".cm-magic-fence-pretty-inputs .cm-magic-fence-pretty-kind": accentText(
        INPUTS_ACCENT,
        {
            fontFamily: "ui-monospace, 'SF Mono', Menlo, Monaco, monospace",
            fontWeight: "600",
            fontSize: "11px",
            letterSpacing: "0.01em",
        },
    ),
    ".cm-magic-fence-pretty-close": {
        opacity: "0.62",
    },
});
